import API from './base';

export const getAppSites = (orgId, appId, page, perPage) =>
  API.managmentGet(
    `organizations/${orgId}/sites/getSitesAvailableForApp/apps/${appId}?page=${page}&perPage=${perPage}`
  );
